import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import WithRender from './RenewRegisterSender.html';
import { Inject } from 'vue-di-container';
import { GetRenewSenderModel } from './GetRenewSenderModel';
import ValidationService from '../../../../Services/ValidationService';
import { SenderType } from '../../../../shared/Enums/SenderType';
import { DropdownModel } from '../../../Provider/ProviderModel';
import { Toaster } from '../../../../Services/toast';
import RenewRegisterSenderService from './RenewRegisterSenderService';
import { GetRenewSenderRequestModel } from './GetRenewSenderRequestModel';
import { RenewRequestModel } from './RenewRequestModel';
import { SenderViewModel } from '../../../ConnectingSenderName/ConnectingSenderNameModel';
import { AddExtendDurationRequestsModel } from './AddExtendDurationRequestsModel';
import OperatorService from '@/Services/OperatorService';
import ProviderService from '@/components/Provider/ProviderService';
import UserService from '../../../../shared/userService/UserService';
import { ProviderModel } from '../../../Provider/ProviderModel';
import VirtualOperatorRules from '@/shared/VirtualOperatorRules';
import {
    clearRenewalPaymentRedirectMark,
    getRouteFromRenewalSource,
    parseRenewalSenderIdsForGrid,
    parseRenewalTemplateRequestIds,
} from '../../../../constants/renewalPaymentRedirect';
import MessageTemplateRenewalService from '@/components/MessageTemplateDashboard/MessageTemplateRenewal/MessageTemplateRenewalService';
import { MessageTemplateRenewalCandidateModel } from '@/components/MessageTemplateDashboard/MessageTemplateRenewal/MessageTemplateRenewalModel';
import {
    TEMPLATE_RENEWAL_NO_TEMPLATES_MESSAGE,
    translateTemplateRenewalMessage,
} from '@/components/MessageTemplateDashboard/MessageTemplateRenewal/templateRenewalMessages';
import DashboardService from '@/components/Dashboard/DashboardService';

const STEP_CLIENT_INFO = 1;
const STEP_RENEWAL_INFO = 2;
const STEP_TEMPLATES = 3;

/** Non-payment exits use renewalSource (extend / sender / contracts). After payment, user lands on Dashboard via Payment / PaymentResult only. */

@WithRender
@Component({
    components: {
    },
    diProvide: [
        RenewRegisterSenderService,
        OperatorService,
        ProviderService,
        UserService,
        MessageTemplateRenewalService,
        DashboardService,
    ],
})
export default class RenewRegisterSender extends Vue {
    @Inject(ValidationService) public validationService!: ValidationService;
    @Inject(RenewRegisterSenderService) public renewRegisterSenderService!: RenewRegisterSenderService;
    @Inject(OperatorService) public operatorService!: OperatorService;
    @Inject(ProviderService) public providerService!: ProviderService;
    @Inject(UserService) public userService!: UserService;
    @Inject(MessageTemplateRenewalService) public messageTemplateRenewalService!: MessageTemplateRenewalService;
    @Inject(DashboardService) public dashboardService!: DashboardService;

    @Prop({ type: Boolean, default: false })
    public layoutSup: boolean | any;

    @Prop({ default: 0 })
    public id!: string;
    public showSenderInfo: boolean = false;
    public isSelectOption: boolean = true;
    public senderName: string = '';
    public typeFile: number = 0;
    public senderNameLength: number = 11;
    public senderType: SenderType[] = [];
    senderNames: SenderViewModel[] = [];
    public selected: SenderViewModel[] = [];
    public selectedSenderIds: string[] = [];
    public extendSubmitInFlight: boolean = false;
    public showOperators: boolean = false;
    public templateCandidates: MessageTemplateRenewalCandidateModel[] = [];
    public selectedTemplateRequestIds: string[] = [];
    public templatesUnavailable: boolean = false;
    public templatesLoading: boolean = false;
    /** Senders without linked templates keep the original single-page renewal (Pay later / Pay now on renewal info). */
    public hasLinkedTemplates: boolean = false;
    public linkedTemplatesChecked: boolean = false;
    public renewalEnabled: boolean = false;
    private renewalOptionsLoaded: boolean = false;
    public templateHeaders: any = [
        { text: this.$t('dashboardPage.templateName'), value: 'templateName', align: 'center', sortable: false },
        { text: this.$t('shared.classification'), value: 'classification', align: 'center', sortable: false },
        {
            text: this.$t('dashboardPage.renewalTemplateType'),
            value: 'isVariableTemplate',
            align: 'center',
            sortable: false,
        },
        {
            text: this.$t('dashboardPage.expiryDate'),
            value: 'currentExpiryDate',
            align: 'center',
            sortable: false,
        },
    ];
    public model: RenewRequestModel = {
        senderId: '',
        duration: 0,
        crNumber: '',
        enterpriseUnifiedNumber: '',
        customerType: 0,
        senderName: '',
    };
    public addModel: AddExtendDurationRequestsModel = {
        senderIds: [],
        duration: 0,
        isAutoActivation: false,
        operators: [],
    };
    public renewRequestModel: RenewRequestModel = {
        senderId: '',
        duration: 0,
        crNumber: '',
        enterpriseUnifiedNumber: '',
        customerType: 0,
        senderName: '',
    };
    public operatorList: string[] =[];
    public provider: ProviderModel = {
        name: '',
        providerCode: '',
        id: '',
        createdDate: null,
        enterpriseUnifiedNumber: '',
        accreditationNumber: '',
        email: '',
        taxNumber: '',
        hasInternational: false,
        country: '',
        city: '',
        district: '',
        streetName: '',
        buildingNumber: '',
        postalCode: '',
        vatNumber: '',
        additionalNumber: '',
        otherIdentifier: '',
        balance: 0,
        creditLimitAmount: 0,
        bankAccountNumber: '',
        expireDate: '',
        state: '',
        isDisconnected: '',
        integrationBaseURL: '',
        isVirtualOperator: false,
        virtualOperatorId: null,
        virtualOperatorName: '',
    };

    public get virtualOperatorConnectivityLocked(): boolean {
        return VirtualOperatorRules.connectivityOperators(this.provider, this.operatorList).locked;
    }

    public get connectivityOperatorList(): string[] {
        return VirtualOperatorRules.connectivityOperators(this.provider, this.operatorList).names;
    }
    public getRenewSenderModel: GetRenewSenderModel = {
        senderId: '',
        clientName: '',
        crNumber: '',
        enterpriseUnifiedNumber: '',
        customerType: 0,
        representativeEmail: '',
        representativeMobile: '',
        representativeName: '',
    };
    public stepNumber: number = 1;
    public enterpriseUnifiedNumberDisabled: boolean = true;
    public renewRequestDialog: boolean = false;
    public headers: any = [
        { text: this.$t('shared.senderName'), value: 'senderName', align: 'center', sortable: false },
        { text: this.$t('shared.senderType'), value: 'senderType', align: 'center', sortable: false },
    ];
    public customerTypeList: DropdownModel[] = [
        {
            id: 1,
            name: this.$t('shared.government').toString(),
        },
        {
            id: 2,
            name: this.$t('shared.charity').toString(),
        },
        {
            id: 3,
            name: this.$t('shared.private').toString(),
        },
        {
            id: 4,
            name: this.$t('shared.international').toString(),
        },
    ];
    public ids: string | any;
    public idsList: string[] = [];
    public async mounted() {
        this.$emit('childinit', this.layoutSup);
        await this.loadRenewalOptions();
        await this.loadRenewalFromRoute();
    }

    @Watch('$route')
    public async onRouteChange() {
        await this.loadRenewalOptions();
        await this.loadRenewalFromRoute();
    }

    private async loadRenewalOptions() {
        if (this.renewalOptionsLoaded) {
            return;
        }
        this.renewalOptionsLoaded = true;
        const response = await this.dashboardService.getRequestsOptions();
        this.renewalEnabled = !!(response && response.result && response.result.isRenewRequstEnabled === true);
    }

    public async loadRenewalFromRoute() {
        if (this.$route.name !== 'RenewRegisterSender') {
            return;
        }
        const idsCombined = parseRenewalSenderIdsForGrid(this.$route as any);
        if (!idsCombined) {
            this.isSelectOption = false;
            this.ids = '';
            this.idsList = [];
            return;
        }
        this.idsList = [];
        this.selected = [];
        this.selectedSenderIds = [];
        this.isSelectOption = true;
        if (this.stepNumber < STEP_RENEWAL_INFO) {
            this.stepNumber = STEP_RENEWAL_INFO;
        }
        this.selectedTemplateRequestIds = parseRenewalTemplateRequestIds(this.$route.query as any);
        this.ids = idsCombined;
        if (this.ids.includes(',')) {
            this.idsList = this.ids.split(',').map((s: string) => s.trim()).filter((x: string) => x.length > 0);
        } else {
            this.idsList.push(this.ids.trim());
        }
        this.addModel.senderIds = this.idsList;
        const response = await this.renewRegisterSenderService
            .GetSendersForRenewBySenderIds(this.addModel.senderIds);
        if (response.isSuccess) {
            this.model.crNumber = response.result[0].crNumber;
            this.model.customerType = response.result[0].customerType;
            this.model.enterpriseUnifiedNumber = response.result[0].enterpriseUnifiedNumber;
            this.selected = response.result;
            this.selected.forEach(name => {
                name.senderTypes = [];
                this.getSenderType(name.senderType, name);
            });
            this.selected.forEach(s => {
                this.selectedSenderIds.push(s.senderId);
            });
            const rd = this.$route.query.renewalDuration;
            if (typeof rd === 'string' && rd.length) {
                const d = parseInt(rd, 10);
                if (!isNaN(d) && d > 0) {
                    this.addModel.duration = d;
                    this.stepNumber = 2;
                }
            }
            const ra = this.$route.query.renewalAutoActivation;
            if (ra === '1') {
                this.addModel.isAutoActivation = true;
                this.show();
            } else if (ra === '0') {
                this.addModel.isAutoActivation = false;
            }
            const ro = this.$route.query.renewalOperators;
            if (typeof ro === 'string' && ro.length) {
                this.addModel.operators = ro.split(',').filter(Boolean);
            }
            this.applyVirtualOperatorConnectivityOperators();
            await this.checkLinkedTemplates();
        } else {
            Toaster.error(response.errorMessage);
        }
    }
    public selectAll() {
        if (this.selected.length) {
            this.selected = [];
            this.selectedSenderIds = [];
        } else {
            this.selected = this.senderNames.slice();
            this.selectedSenderIds = this.senderNames.map((x) => x.senderId);
        }
    }
    public senderTypeList: DropdownModel[] = [
        {
            id: SenderType.Advertisement,
            name: this.$t('shared.advertisement').toString(),
        },
        {
            id: SenderType.Service,
            name: this.$t('shared.service').toString(),
        },
        {
            id: SenderType.Awareness,
            name: this.$t('shared.awareness').toString(),
        },
        {
            id: SenderType.Warning,
            name: this.$t('shared.warning').toString(),
        },
    ];
    public durationList: DropdownModel[] = [
        {
            id: 1,
            name: '1',
        },
        {
            id: 2,
            name: '2',
        },
        {
            id: 3,
            name: '3',
        },
        {
            id: 4,
            name: '4',
        },
        {
            id: 5,
            name: '5',
        },
    ];
    public get isValidApply(): boolean {
        const needsCr = this.model.customerType !== 3;
        const hasCr = this.model.crNumber.trim() !== '';
        const unifiedValid =
            (this.model.customerType === 2 || this.model.customerType === 3)
                ? this.model.enterpriseUnifiedNumber.trim() !== ''
                : true;
        return (
            this.model.customerType !== 0 &&
            (!needsCr || hasCr) &&
            unifiedValid
        );
    }
    public getModel: GetRenewSenderRequestModel = {
        senderName: ''
    };
    public async created() {
         const response = await this.operatorService.getAll();

        if (response.isSuccess) {
            this.operatorList = response.result.map((op: any) => op.name);
        }

        const user = await this.userService.getUser();
        if (user && user.details && user.details.ProviderId) {
            this.provider = await this.providerService.GetById(user.details.ProviderId);
            this.applyVirtualOperatorConnectivityOperators();
        }

        this.$emit('childinit', this.layoutSup);
    }
    public newRequest() {
        this.reset();
        this.stepNumber = 1;
    }
    public get isValidStep(): boolean {
        return (this.selected.length != 0);
    }
    public get isValidExtend(): boolean {
        if (this.addModel.duration === 0) {
            return false;
        }
        const auto = this.addModel.isAutoActivation === true
            || String(this.addModel.isAutoActivation) === 'true';
        if (!auto) {
            return true;
        }
        return !!(this.addModel.operators && this.addModel.operators.length > 0);
    }
    /** Eligibility only widens with a longer extension; used before a duration is chosen. */
    public get maxDuration(): number {
        return Math.max(...this.durationList.map((d) => Number(d.id)));
    }
    public get canOfferTemplatesStep(): boolean {
        return this.selectedSenderIds.length === 1 && this.renewalEnabled;
    }

    public get showTemplatesStep(): boolean {
        return this.canOfferTemplatesStep && !this.templatesUnavailable;
    }

    public get useLegacyLayout(): boolean {
        return !this.canOfferTemplatesStep
            || this.templatesUnavailable
            || (this.linkedTemplatesChecked && !this.hasLinkedTemplates);
    }

    public get isRenewalLayoutReady(): boolean {
        return !this.canOfferTemplatesStep || this.linkedTemplatesChecked;
    }

    public get showStepper(): boolean {
        return !(this.isSelectOption && this.useLegacyLayout);
    }

    public get visibleSteps(): Array<{ id: number, label: string }> {
        const steps: Array<{ id: number, label: string }> = [];
        if (!this.isSelectOption) {
            steps.push({ id: STEP_CLIENT_INFO, label: this.$t('shared.clientInfo').toString() });
        }
        steps.push({ id: STEP_RENEWAL_INFO, label: this.$t('shared.renewalInfo').toString() });
        if (!this.useLegacyLayout) {
            steps.push({ id: STEP_TEMPLATES, label: this.$t('shared.templatesRenewal').toString() });
        }
        return steps;
    }

    public get stepperValue(): number {
        const index = this.visibleSteps.findIndex((s) => s.id === this.stepNumber);
        return index + 1;
    }

    public get selectedTemplates(): MessageTemplateRenewalCandidateModel[] {
        return this.templateCandidates.filter((c) => this.selectedTemplateRequestIds.indexOf(c.requestId) !== -1);
    }

    public async next() {
        if (this.stepNumber === STEP_CLIENT_INFO) {
            this.templatesUnavailable = false;
            this.stepNumber = STEP_RENEWAL_INFO;
            await this.checkLinkedTemplates();
            return;
        }
        if (this.stepNumber === STEP_RENEWAL_INFO && await this.loadTemplateCandidates()) {
            this.stepNumber = STEP_TEMPLATES;
        }
    }

    public back() {
        const index = this.visibleSteps.findIndex((s) => s.id === this.stepNumber);
        if (index > 0) {
            this.stepNumber = this.visibleSteps[index - 1].id;
        }
    }

    public isTemplateSelected(item: MessageTemplateRenewalCandidateModel): boolean {
        return this.selectedTemplateRequestIds.indexOf(item.requestId) !== -1;
    }

    public toggleTemplate(item: MessageTemplateRenewalCandidateModel, checked: boolean) {
        if (!item.isEligible) {
            return;
        }
        const index = this.selectedTemplateRequestIds.indexOf(item.requestId);
        if (checked && index === -1) {
            this.selectedTemplateRequestIds.push(item.requestId);
        } else if (!checked && index !== -1) {
            this.selectedTemplateRequestIds.splice(index, 1);
        }
    }

    public reset() {
        this.model = {
            senderId: '',
            duration: 0,
            crNumber: '',
            enterpriseUnifiedNumber: '',
            customerType: 0,
            senderName: '',
        };
        this.senderType = [];
    }
    public getSenderTypeText(typeId: number) {
        switch (typeId) {
            case SenderType.Advertisement:
                return this.$t('shared.advertisement').toString();
            case SenderType.Service:
                return this.$t('shared.service').toString();
            case SenderType.Awareness:
                return this.$t('shared.awareness').toString();
            case SenderType.Warning:
                return this.$t('shared.warning').toString();
            default:
                return '-';
        }
    }
    public getSenderType(type: number, sender: SenderViewModel) {
        sender.senderTypes = [];
        const senderBinary = type;
        if ((senderBinary & 1) === 1) {
            sender.senderTypes.push(1);
        }
        if ((senderBinary & 2) === 2) {
            sender.senderTypes.push(2);
        }
        if ((senderBinary & 4) === 4) {
            sender.senderTypes.push(4);
        }
        if ((senderBinary & 8) === 8) {
            sender.senderTypes.push(8);
        }
    }
    public getCustomerTypeText(typeId: number) {
        switch (typeId) {
            case 1:
                return this.$t('shared.government').toString();
            case 2:
                return this.$t('shared.charity').toString();
            case 3:
                return this.$t('shared.private').toString();
            case 4:
                return this.$t('shared.international').toString();
            default:
                return '-';
        }
    }
    public select(event: any, id: string) {
        if (!event) {
            const index = this.selectedSenderIds.indexOf(id);
            this.selectedSenderIds.splice(index, 1);
        } else {
            let selectedObj = this.selected.find(s => s.id == id);
            if (selectedObj !== undefined) {
                this.selectedSenderIds.push(selectedObj.senderId);
            }
        }
    }
    public isNumberField(val: KeyboardEvent) {
        if (!this.validationService.isNumber(val.key)) {
            val.preventDefault();
        }
    }
    public isSenderNameField(val: KeyboardEvent) {
        const pattern = /^[-a-zA-Z0-9._& ]*$/;
        if (!pattern.test(val.key)) {
            val.preventDefault();
        }
    }
    public isNumberFieldPaste(ev: any) {
        const paste = (ev.clipboardData).getData('text');
        if (isNaN(paste)) {
            ev.preventDefault();
        }
    }
    public isSenderNameFieldPaste(ev: any) {
        const paste = (ev.clipboardData).getData('text');
        const pattern = /^[-a-zA-Z0-9._& ]*$/;
        if (!pattern.test(paste)) {
            ev.preventDefault();
        }
    }
    public get isValid(): boolean {
        return (this.model.duration.toString().trim() !== ''
            && this.model.duration !== 0);
    }
    public cancel() {
        this.$router.push(getRouteFromRenewalSource(this.$route.query.renewalSource));
    }
    public async confirmExtendPayNow() {
        this.addModel.senderIds = this.selectedSenderIds;
        if (!this.addModel.senderIds.length || !this.addModel.duration) {
            return;
        }
        const q: Record<string, string> = {
            fromRenewal: '1',
            renewPayNowDeferred: '1',
            renewalDuration: String(this.addModel.duration),
            renewalAutoActivation: this.addModel.isAutoActivation ? '1' : '0',
            renewalOperators: (this.addModel.operators || []).join(','),
        };
        const src = this.$route.query.renewalSource;
        if (typeof src === 'string' && src.length > 0) {
            q.renewalSource = src;
        }
        const renewalSenderIds = this.selectedSenderIds.map((id) => String(id)).join(',');
        q.renewalSenderIds = renewalSenderIds;
        const templateRequestIds = this.getSubmittableTemplateRequestIds();
        if (templateRequestIds.length) {
            q.renewalTemplateRequestIds = templateRequestIds.join(',');
        }
        await this.$router.push({
            name: 'Payment',
            query: q,
        });
    }

    public async confirmExtendPayLater() {
        await this.submitExtendRenewal(async (_idsJoined: string) => {
            clearRenewalPaymentRedirectMark();
            Toaster.success(this.$t('shared.senderRenewalRequestAddedSuccessfully').toString());
            await this.createTemplateRenewals();
            await this.$router.push(getRouteFromRenewalSource(this.$route.query.renewalSource));
        });
    }

    private async createTemplateRenewals() {
        const templateRequestIds = this.getSubmittableTemplateRequestIds();
        if (!templateRequestIds.length) {
            return;
        }
        const response = await this.messageTemplateRenewalService.Renew(templateRequestIds, true);
        if (!response || !response.isSuccess) {
            const errorMessage = response && response.errorMessage ? response.errorMessage : '';
            const translated = translateTemplateRenewalMessage(errorMessage, (key: string) => this.$t(key).toString());
            Toaster.error(translated !== null
                ? translated
                : (errorMessage || this.$t('shared.errorOccurred').toString()));
            return;
        }
        Toaster.success(this.$t('shared.templateRenewalsPendingPayment').toString());
    }

    private getSubmittableTemplateRequestIds(): string[] {
        if (!this.showTemplatesStep) {
            return [];
        }
        return this.selectedTemplates.filter((t) => t.isEligible).map((t) => t.requestId);
    }

    private async loadTemplateCandidates(): Promise<boolean> {
        if (!this.canOfferTemplatesStep || this.templatesLoading) {
            this.templatesUnavailable = true;
            return false;
        }
        this.templatesLoading = true;
        try {
            const response = await this.messageTemplateRenewalService
                .GetCandidatesBySender(this.selectedSenderIds[0], this.addModel.duration);
            if (!response || !response.isSuccess || !response.result) {
                this.templateCandidates = [];
                this.selectedTemplateRequestIds = [];
                this.templatesUnavailable = true;
                this.notifyTemplatesStepSkipped(response && response.errorMessage ? response.errorMessage : '');
                return false;
            }
            this.templateCandidates = (response.result.templates || [])
                .filter((c: MessageTemplateRenewalCandidateModel) => c.isEligible);
            if (!this.templateCandidates.length) {
                this.selectedTemplateRequestIds = [];
                this.templatesUnavailable = true;
                return false;
            }
            const eligibleIds = this.templateCandidates.map((c) => c.requestId);
            this.selectedTemplateRequestIds = this.selectedTemplateRequestIds
                .filter((id) => eligibleIds.indexOf(id) !== -1);
            this.templatesUnavailable = false;
            return true;
        } finally {
            this.templatesLoading = false;
        }
    }

    private async checkLinkedTemplates(): Promise<void> {
        this.linkedTemplatesChecked = false;
        this.hasLinkedTemplates = false;
        if (!this.canOfferTemplatesStep) {
            return;
        }
        try {
            const response = await this.messageTemplateRenewalService
                .GetCandidatesBySender(this.selectedSenderIds[0], this.addModel.duration || this.maxDuration);
            this.hasLinkedTemplates = !!(response && response.isSuccess && response.result
                && response.result.templates && response.result.templates
                    .some((t: MessageTemplateRenewalCandidateModel) => t.isEligible));
        } finally {
            this.linkedTemplatesChecked = true;
        }
    }

    private notifyTemplatesStepSkipped(errorMessage: string) {
        if (errorMessage === TEMPLATE_RENEWAL_NO_TEMPLATES_MESSAGE) {
            return;
        }
        const translated = translateTemplateRenewalMessage(errorMessage, (key: string) => this.$t(key).toString());
        Toaster.error(this.$t('dashboardPage.templateRenewalStepUnavailable').toString()
            + (translated !== null ? ' ' + translated : ''));
    }

    private async submitExtendRenewal(onSuccess: (idsJoined: string) => Promise<void>) {
        if (this.extendSubmitInFlight) {
            return;
        }
        this.extendSubmitInFlight = true;
        this.addModel.senderIds = this.selectedSenderIds;
        try {
            const response = await this.renewRegisterSenderService.AddExtendRequest(this.addModel);
            if (!response || !response.isSuccess) {
                Toaster.error(
                    (response && response.errorMessage) || this.$t('shared.errorOccurred').toString(),
                );
                await this.$router.push(getRouteFromRenewalSource(this.$route.query.renewalSource));
                return;
            }
            const raw = response.result && response.result.ids;
            if (!raw || !(raw as string[]).length) {
                Toaster.error(this.$t('shared.errorOccurred').toString());
                await this.$router.push(getRouteFromRenewalSource(this.$route.query.renewalSource));
                return;
            }
            const idsJoined = (raw as string[]).map((id) => String(id)).join(',');
            await onSuccess(idsJoined);
        } finally {
            this.extendSubmitInFlight = false;
        }
    }
    public async apply() {
        const response = await this.renewRegisterSenderService
            .GetSendersForRenew(this.model.senderName, this.model.crNumber, this.model.customerType, this.model.enterpriseUnifiedNumber);
        if (response.isSuccess) {
            this.senderNames = response.result;
            this.senderNames.forEach(name => {
                name.senderTypes = [];
                this.getSenderType(name.senderType, name);
            });
            this.showSenderInfo = true;
        } else {
            Toaster.error(response.errorMessage);
            this.showSenderInfo = false;
        }
    }

    public hide() {
        this.showOperators = false;
    }
    public show() {
        this.showOperators = true;
        this.applyVirtualOperatorConnectivityOperators();
    }

    private applyVirtualOperatorConnectivityOperators() {
        const operators = VirtualOperatorRules.applyAutoConnectivityOperators(
            this.provider,
            this.addModel.isAutoActivation);
        if (operators) {
            this.addModel.operators = operators;
        }
    }
}